<template>
  <div :class="['cams-dialog', className]">
    <div class="cams-dialog__body">
      <div v-if="dialogTitle" class="cams-dialog__title">
        {{ dialogTitle }}
      </div>

      <component :is="componentWithContent" v-bind="propsForContent" class="cams-dialog__content" />
    </div>

    <CamsButton
      class="cams-dialog__button-close"
      icon-type="only"
      type="button"
      @click="closeDialog()"
    >
      <svg class="cams-dialog__icon-button-close">
        <use xlink:href="./img/icons.svg#icon-close-modal" />
      </svg>
    </CamsButton>
  </div>
</template>

<script>
import {methodsForDialogMixin} from "./mixins.js";

/**
 * Компонент универсального шаблона для кастомных модалок.
 */
export default {
  mixins: [methodsForDialogMixin],
  props: {
    /**
     * Компонент для отображения внутри диалога.
     */
    componentWithContent: {
      required: true,
      type: Object,
    },
    /**
     * Свойства для проброса в переданный компонент.
     */
    propsForContent: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Заголовок для диалогового окна.
     */
    dialogTitle: {
      type: String,
      default: "",
    },
    /**
     * Проброс дополнительных стилей для кастомизации модального окна.
     */
    className: {
      type: String,
      default: '',
    }
  },
};
</script>
<style lang="scss">
@use "./scss/style.scss";
</style>
